module.exports = function transformFormBlockData(entity, formsConfig) {
	const form_key = entity.attributes.field_form_key;
	const form_config = formsConfig.find((f) => f.form_key === form_key);
	if (!form_config) return {};
	return {
		type: entity.type,
		id: entity.id,
		form_key,
		...form_config,
	};
};
